import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  departments: [],
  department: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  filterArray: [],
  pagination: {},
};
const getters = {
  departmentsListGet: (state) => state.departments,
  departmentGet: (state) => state.department,
  paginationGet: (state) => state.pagination,
};
const actions = {
  getDepartments({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    let param = new URLSearchParams();
    if (payload.directorateId) {
      param.append("directorate_id", payload.directorateId);
    }
    const url = `/departments?${param.toString()}&page=${page}`;

    service.getFun(url).then(
      (obj) => {
        var result = obj.data.data;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj?.data.last_page,
          itemsPerPage: obj?.data?.per_page,
          total: obj.data.total,
        };
        commit("departmentsListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getDepartmentById({ commit }, payload) {
    service.getFun(`department/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("getDepartmentByIdSet", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addDepartment({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `department/store`, null, {
        action: "getDepartments",
        page: store.state.page.page,
      })
      .then(
        (result) => {
          if (result) {
            commit("addDepartmentStatus", result.success);
            toast(result.message);
          } else {
            commit("addDepartmentStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editDepartment({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `department/edit/${payload.id}`,
        null,
        {
          action: "getDepartments",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editDepartmentStatus", result.success);
            toast(result.message);
          } else {
            commit("editDepartmentStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async deleteDepartment({ commit }, payload) {
    const res = await service.postFun(
      null,
      `department/delete/${payload.payload}`,
      null,
      {
        action: "getDepartments",
        page: store.state.page.page,
      }
    );
    if (res) {
      commit("deleteDepartmentStatus", res.success);
      toast(res.message);
    }
  },
};
const mutations = {
  departmentsListSet(state, departments) {
    state.departments = departments;
  },
  addDepartmentStatus(state, Status) {
    state.addStatus = Status;
  },
  getDepartmentByIdSet(state, department) {
    state.department = department;
  },
  editDepartmentStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteDepartmentStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
